<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>Route History</strong>
          </div>
          <b-row>
            
            <b-col md="4">
              <b-form-group>
                <b-row>
                  <b-col sm="3">
                    <!-- <label for="Hub"><b>Hub</b></label>&nbsp;<span style="color: red;">*</span> -->
                    <span for="Hub"><b>Hub</b>&nbsp;<b style="color: red;">*</b></span>
                  </b-col>
                  <b-col sm="9">
                    <v-select v-model="selectedHub" :options="optionsHub" placeholder="-- Select Hub --" @change="onCHange"></v-select>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          
            <b-col md="4">
              <!-- {{ selectedHub }} -->
              <!-- <b-button variant="primary" :pressed.sync="myToggle">Submit</b-button> -->
                <b-button type="submit" size="md" variant="danger" @click="clear()" style="margin-left: 10px"> Clear</b-button>
            </b-col>
          </b-row>
          <div>
            <b-row>
              <b-col md="12">
                <ul class="nav nav-tabs nav-justified">
                    <li class="nav-item">
                        <a class="nav-link" @click="activeTab = 0" :class="{'active': isActiveTab(0)}">Generate Route</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" @click="activeTab = 1" :class="{'active' : isActiveTab(1)}">Freeze Route</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" @click="activeTab = 2" :class="{'active' : isActiveTab(2)}">Final Generated Route</a>
                    </li>
                </ul>
              </b-col>
            </b-row>
          </div>
          <div>
            <b-row>
              <b-col md="12">
                  <div class="tab-panel" v-if="isActiveTab(0)">
                      <route_generate :selectedHub="selectedHub" @freeze-clicked="switchToFreezeTab"></route_generate>
                  </div>
                  <div class="tab-panel" v-if="isActiveTab(1)">
                      <route_freeze :selectedHub="selectedHub" @generated-clicked="switchToGenerateTab"></route_freeze>
                  </div>
                  <div class="tab-panel" v-if="isActiveTab(2)">
                      <route_final :selectedHub="selectedHub"></route_final>
                  </div>
              </b-col>
            </b-row>
            </div>
        </b-card>

      </b-col>
    </b-row> 
  </div>
</template>
<script>
  //  import DirectionsRenderer from "./DirectionsRenderer";
   import spinner from './Loader/spinner.vue';
   import route_generate from './route_generate.vue';
   import route_freeze from './route_freeze.vue'
   import route_final from './route_final.vue'
  //  import customMarker from "./customMarker.vue";
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import Vue from "vue";
  export default {
    data() {
      return {
        optionsHub: [],
        selectedHub: '',
        activeTab:0,
        route_generate,
        route_freeze,
        route_final,
        accessBody:[],
      isReadOnly:false,
      };
    },
    components: {
    // DirectionsRenderer,
    spinner,
    route_generate,
    route_freeze,
    route_final
    // customMarker,
    },
    created() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.userType = userInfo.user_type;
      this.Usersysuser = userInfo.sysusermasterid;
      this.user_id = userInfo.sysusermasterid;
      this.accessBody = userInfo.body;
          console.log("--------->>>>>>>>>>",userInfo.body)
          this.ischeckbodyvalidation();
      this.isActiveTab(0);
      this.showWHlist();
      // this.getRoute();
    },
    methods: {
      ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=="Route History" && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=="Route History" && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
      isActiveTab(id){
            return this.activeTab === id
       },
      showWHlist: function() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var csvObj = {
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`
        };
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj).then(result => {
          if (result.body.returnmsg === 'Successful') {
            this.optionsHub = [];
            this.HubData = result.body.returnvalue;
            var data = [];
            this.HubData.forEach(function(srData) {
              data.push({
                key: srData.hubid,
                label: srData.hubid + " - " + srData.hubname
              });
            });
            this.optionsHub = data;
          } else {
            this.HubData = [];
          }
        }).catch(ex => {
          console.log("error-----", ex);
        });
      },
      clear: function() {
        // this.activeTab(0);
        this.selectedHub='';
        localStorage.setItem('destination_sequence', '');
        localStorage.setItem('loads', '');
        localStorage.setItem('vehicleDetails', '');
        localStorage.setItem('pendingLoads', '')
        localStorage.setItem('freezevehicleDetails', '');
        localStorage.setItem('freezePendingLoads', '');
        console.log("this.activeTab",this.activeTab)
        this.activeTab=0;
        this.isActiveTab(this.activeTab);
      },
      onCHange(){
        if(this.selectedHub==null){
          this.selectedHub=''
          this.activeTab(0);
        }
      },
      switchToFreezeTab() {
        this.activeTab = 1; // Set the active tab to "Freeze Route"
      },
      switchToGenerateTab() {
        this.activeTab = 2; // Set the active tab to "Freeze Route"
      },
    },
    
  };
</script>
<style scoped>
.custom-source-marker-container {
  position: absolute;
  z-index: 999; /* Adjust the z-index value to ensure it's above the DirectionsRenderer markers */
  top: 0; /* Adjust positioning as needed */
  left: 0; /* Adjust positioning as needed */
}
  .routetable th,
  td,th {
    text-align: center;
  }

  .route-border {
    border-bottom: 1px solid #c9bebe;
    margin: 30px 0px 20px 0px;
  }

  #overlay {
    position: fixed;
    /* Sit on top of the page content */
    /*display: none;*/
    /* Hidden by default */
    width: 100%;
    /* Full width (cover the whole page) */
    height: 100%;
    /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    /* Black background with opacity */
    z-index: 9999;
    /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer;
    /* Add a pointer on hover */
  }

  .loader {
    position: fixed;
    ;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #3498db;
    width: 50px;
    height: 50px;
    left: 50%;
    top: 50%;
    -webkit-animation: spin 2s linear infinite;
    /* Safari */
    animation: spin 2s linear infinite;
  }

  .loading {
    position: relative;
    width: 50px;
    height: 50px;
    left: 50%;
    top: 56%;
  }
  .customMarker{
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: -1;
  }

  /* Safari */
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
  .dot{
    margin: 5px;
  }
  .red-dot {
  width: 20px;
  height: 20px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  border: 2px black solid;
}
.green-dot {
  width: 20px;
  height: 20px;
  background-color: green;
  border-radius: 50%;
  display: inline-block;
  border: 2px black solid;
}
.yellow-dot {
  width: 20px;
  height: 20px;
  background-color: yellow;
  border-radius: 50%;
  display: inline-block;
  border: 2px black solid;
}
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>